// extracted by mini-css-extract-plugin
export default {"containerWrapper":"styles_containerWrapper__HzHdN","errorWrapper":"styles_errorWrapper__rfBhk","logoWrapper":"styles_logoWrapper__nMzKG"};